import { SnackbarStore } from '@yard/stores/snackbar.store'
import { makeAutoObservable } from 'mobx'
import { DGStackingRuleFormProfile } from '../forms/dg-stacking-rules-table-form/dg-stacking-rules-table-form.profile'
import { DGStackingRuleStore } from './dg-stacking-rule.store'

export class DGStackingRulesTableUIStore {
  isDialogOpen = false
  isResetDialogOpen = false
  dialogEntityId?: string

  constructor(
    private readonly _dgStackingRuleStore: DGStackingRuleStore,
    private readonly _snackbarStore: SnackbarStore,
  ) {
    makeAutoObservable(this)
  }

  get dgStackingRules() {
    return this._dgStackingRuleStore.entries
  }

  loadAllDGStackingRules = async () => await this._dgStackingRuleStore.loadAll()

  get dialogEntity() {
    if (!this.dialogEntityId) return undefined
    return this._dgStackingRuleStore.getById(this.dialogEntityId)
  }

  openEditDialog = (entityId: string) => {
    this.dialogEntityId = entityId
    this.isDialogOpen = true
  }

  closeDialog = () => {
    this.isDialogOpen = false
    this.dialogEntityId = undefined
  }

  toggleResetDialog = () => {
    this.isResetDialogOpen = !this.isResetDialogOpen
  }

  update = async (
    { id, isStackingOnTopAllowed, maxTiers }: DGStackingRuleFormProfile,
    onFinally: () => void,
  ) => {
    if (!id) return
    try {
      await this._dgStackingRuleStore.update(id, {
        maxTiers: maxTiers ?? 0,
        isStackingOnTopAllowed,
      })
      this._snackbarStore.showMessage('The DG stacking rule was updated successfully', 'success')
      await this._dgStackingRuleStore.loadAll()
    } catch (e) {
      this._snackbarStore.showMessage('An unexpected error occurred while updating the DG stacking rule', 'error')
    } finally {
      onFinally()
    }
  }

  resetToDefaults = async () => {
    try {
      await this._dgStackingRuleStore.resetToDefaults()
      this._snackbarStore.showMessage('DG stacking rules reset to defaults successfully', 'success')
    } catch (e) {
      this._snackbarStore.showMessage('An unexpected error occurred while resetting the DG stacking rules', 'error')
    } finally {
      this.toggleResetDialog()
    }
  }
}
